import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LineModalTemplateService } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.service';

import { Identity, Customer, IdentityCustomerProfile, VerifyIdentity } from '../models/customer.model';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';

import { VerifyCustomer, VerifyRegistration, VerifyLineID, VerifyPreRegistration } from '../models/verify.model';
import { catchError, map } from 'rxjs/operators';
// import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class FormVerifyCustomerService {


  private lineServiceUrl: string = environment.endpointBackend + '/api/line';

  constructor(
    private http: HttpClient,
    private lineModalService: LineModalTemplateService
  ) { }

  //API ตรวจสอบข้อมูลลูกค้า
  apiVerityCuestomer(payload: VerifyIdentity): Observable<PayloadResponse<VerifyCustomer>> {
    return this.http.post<ApiResponse<Customer>>(this.lineServiceUrl + '/verify/customer', payload).pipe(
      map(
        response => {
           return response.response_code === ResponseStatus.SUCCESS ? response.payload : null
        }
      )
    )
  }

  //API ตรวจสอบสถานะการลงทะเบียน
  apiVerifyRegistration(payload: VerifyRegistration): Observable<PayloadResponse<Identity>> {
    return this.http.post<ApiResponse<Identity>>(environment.endpointBackend + '/api/line/verify/registration', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

  //API ตรวจสอบสถานะการลงทะเบียน
  apiVerifyPreRegistration(payload: VerifyPreRegistration): Observable<PayloadResponse<null>> {
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/verify/lineID/pre-register', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

  //API ตรวจสอบ Line id ลูกค้า
  apiVerifyLineID(payload: VerifyLineID): Observable<PayloadResponse<null>> {
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/verify/lineID', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

  //API แก้เบอร์โทร phone not match
  apiUpdatePhoneNotMatch(payload: VerifyLineID): Observable<PayloadResponse<null>> {
    return this.http.post<ApiResponse<null>>(this.lineServiceUrl + '/update/phone', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

  apiGetLeadCustomerRegistration(payload): Observable<PayloadResponse<IdentityCustomerProfile>> {
    return this.http.post<ApiResponse<IdentityCustomerProfile>>(environment.endpointBackend + '/api/line/getCustomerLeadRegister', payload).pipe(
      map(
        response => {
          let result:PayloadResponse<IdentityCustomerProfile>;
          if (response.response_code === ResponseStatus.SUCCESS) {
            result = response.payload;
            result.state_code = ResponseStatus.SUCCESS;
            return result;
          }
          result = response.payload;
            result.state_code = ResponseStatus.INTERNALERROR;
            result.data = null;
            return result;
        }
      )
    )
  }

  apiGetLeadCustomerRegistrationByLine(payload): Observable<PayloadResponse<any>> {
    return this.http.post<ApiResponse<any>>(environment.endpointBackend + '/api/line/getCustomerLeadRegisterByLine', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

  checkCarCenterForAppointment(payload): Observable<PayloadResponse<any>> {
    return this.http.post<ApiResponse<any>>(environment.endpointBackend + '/api/line/checkCarCenterForAppointment', payload).pipe(
      map(
        response =>
          response.response_code === ResponseStatus.SUCCESS ? response.payload : null
      )
    )
  }

}
